import React from 'react';
import styled, { css } from 'styled-components';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import generateRender from 'shared/utils/generateRender';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 27%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  height: 101%;
  aspect-ratio: 174 / 90;

  ${({ theme }) => theme.breakpoints.up('xl')} {
    left: 29%;
  }

  ${({ theme }) =>
    theme.screens.devices(['mobile-standalone', 'mobile-browser']) &&
    `
    left: 11.5vw;
    height: 101%;
  `}
  ${({ theme }) =>
    theme.screens.devices(['tablet-standalone', 'tablet-browser']) &&
    `
    left: 19vw;
    height: 101%;
  `}
  ${({ theme }) =>
    theme.platform('ios') &&
    theme.screens.devices(['tablet-standalone', 'tablet-browser']) &&
    `
    left: 18vw;
    height: 101%;
  `}
  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.device('mobile-standalone') &&
    `
    left: 12vw;
    height: 101%;
  `}
  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.device('mobile-browser') &&
    `
    left: 9.5vw;
  `}
`;

const GhostContainer = styled(Wrapper)`
  position: relative;
  left: unset !important;
  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.device('mobile-browser') &&
    `
    left: unset !important;
    width: 5vw;
  `}
`;

const Background = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const TextContainer = styled.div`
  position: relative;
  z-index: 1;
  width: 88%;
  height: 88%;
  display: flex;
  flex-direction: column;
  align-items: center;
  left: 0.1vw;
  justify-content: center;
  ${({ theme }) =>
    theme.screens.devices(['mobile-standalone', 'mobile-browser']) &&
    `
    left: unset;
  `}
  ${({ theme }) =>
    theme.platform('ios') &&
    theme.screens.devices(['tablet-standalone', 'tablet-browser']) &&
    `
    top: 0.1vw;
  `}
`;

const defaultBadgeTextStyle = css`
  ${({ theme }) =>
    theme.screens.devices(['mobile-standalone', 'mobile-browser']) &&
    `
    font-size: 1.4vw;
  `}
  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.devices(['tablet-standalone', 'tablet-browser']) &&
    `
    font-size: 1.4vw;
  `}
  ${({ theme }) =>
    theme.platform('ios') &&
    theme.screens.devices(['tablet-standalone', 'tablet-browser']) &&
    `
    font-size: 1.6vw;
    transform: translateY(-0.12vw) translateX(0.3vw);
  `}
`;

const sgaBadgeTextStyle = css`
  ${({ theme }) =>
    theme.screens.devices(['mobile-standalone', 'mobile-browser']) &&
    `
    font-size: 1.4vw;
  `}
  ${({ theme }) =>
    theme.platform('ios') &&
    theme.screens.devices(['mobile-standalone', 'mobile-browser']) &&
    `
    font-size: 1.4vw;
    transform: translateY(0.12vw) translateX(0.3vw);
  `}
  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.devices(['tablet-standalone', 'tablet-browser']) &&
    `
    font-size: 1.4vw;
  `}
  ${({ theme }) =>
    theme.platform('ios') &&
    theme.screens.devices(['tablet-standalone', 'tablet-browser']) &&
    `
    font-size: 1.6vw;
    transform: translateY(0.12vw) translateX(0.3vw);
  `}
`;

const bagdeTextStyle = generateRender({
  default: defaultBadgeTextStyle,
  sga: sgaBadgeTextStyle,
});

const TextStack = styled.span`
  position: relative;
  display: inline-block;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
  font-size: 1.6vw;
  transform: translateX(0.25vw);
  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: 1.7vw;
  }
  ${bagdeTextStyle}
`;

const TopShadow = styled.span`
  position: absolute;
  inset: 0;
  transform: translateY(2px);
  color: #8b1f44;
`;

const GradientFill = styled.span`
  position: relative;
  display: inline-block;
  color: transparent;
  background-image: linear-gradient(180deg, #fff9cf 0%, #ffd953 48%, #da7001 52%, #ff8f00 65%, #ff8f00 100%);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const TextStrokeOuter = styled.span`
  position: absolute;
  inset: 0;
  color: #8b1f44;
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke: 2px #8b1f44;
  paint-order: stroke fill;
  text-shadow:
    0 0 0 #8b1f44,
    0 0.1em 0 #8b1f44;
`;

function ExclusiveSaleBadge({ percent = 0 }) {
  return (
    <>
      <GhostContainer />
      {percent > 0 ? (
        <Wrapper>
          <Background src={assetSource(ASSET_KEY.COINS_STORE_OFFER_BADGE)} alt="offer-badge" />
          <TextContainer>
            <TextStack>
              <TopShadow aria-hidden>{`${percent}%`}</TopShadow>
              <TextStrokeOuter>{`${percent}%`}</TextStrokeOuter>
              <GradientFill>{`${percent}%`}</GradientFill>
            </TextStack>
          </TextContainer>
        </Wrapper>
      ) : null}
    </>
  );
}

export default ExclusiveSaleBadge;

